import { appSettings } from './../../../../environments/app.setings';
import { VisualizacaoDocumentacaoComponent } from './../visualizacao-documentacao/visualizacao-documentacao.component';
import { CustomModalService } from '../../../shared/modais/custom-modal/custom-modal.service';
import {
  Component,
  Input,
  ViewChild,
  OnInit,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core';
import { ModalComponent } from '../../modais/modal/modal.component';
import { ReportService } from '../../../services/report/report.service';
import {
  VehicleAccessory,
  VehicleState,
  Report,
} from '../../models/report/report.model';
import { DialogService } from '../../../services/dialog/dialog.service';
import { clearJSONReferences, normalizeList } from '../../helper/helper';
import { RenavanPartner } from '../../partner/renavan-partner';

@Component({
  selector: 'app-report-documentation-item',
  templateUrl: './report-documentation-item.component.html',
  styleUrls: ['./report-documentation-item.component.scss'],
})
export class ReportDocumentationItemComponent implements OnInit {
  @ViewChild('modalReport', { static: true }) modalReport: ModalComponent;
  @ViewChild('inputRenavam', { static: true }) inputRenavam: ElementRef;
  @Input() document: any;
  @Input() proposalId: number;
  @Input() reportCopy: Report;
  @Input() timeline: any;
  @Output() changeReport = new EventEmitter();
  report: Report;
  reportStep: number;
  reportInfo: any;
  vehicleAccessories: VehicleAccessory[];
  originalVehicleAccessories: VehicleAccessory[];
  vehicleStates: VehicleState[];
  originalVehicleStates: VehicleState[];
  incorrectRenavam: boolean;
  requestedRenavam: string;
  renavam: string;
  isRenavamInvalid = false;

  constructor(
    private reportService: ReportService,
    private dialodService: DialogService,
    private modalService: CustomModalService,
  ) {}

  async ngOnInit() {
    await this.recordReportInfo();

    if (this.reportInfo.vehicleType === 'AUTOMOVEL') {
      this.recordVehicleAccessories();
    }

    this.recordVehicleStates();
  }

  openReportModal() {
    this.reportStep = 1;

    this.modalReport.show();
  }

  closeReportModal() {
    this.modalReport.hide();
  }

  updateReport(report: Report) {
    this.reportCopy = clearJSONReferences(report);
    this.report = report;

    this.changeReport.emit(report);
  }

  updateDocument() {
    const report = {
      ...this.report,
      states: this.vehicleStates,
      renavam: this.renavam,
    };

    if (Array.isArray(this.vehicleAccessories)) {
      report.accessories = this.vehicleAccessories.map(
        (acessory: VehicleAccessory) => ({
          ...acessory,
          selected: !!acessory.selected,
        })
      );
    }

    this.updateReport(report);

    this.closeReportModal();
  }

  createReport() {
    if (this.reportCopy) {
      const message =
        'Já existe um documento preenchido, deseja gerar um novo laudo? Isso vai substituir as informações preenchidas anteriormente.';
      this.dialodService.confirm({
        body: message,
        callbackSuccess: () => this.updateDocument(),
      });
    } else {
      this.updateDocument();
    }
  }

  async recordReportInfo() {
    const response = await this.reportService
      .recordReportInfo(this.proposalId)
      .toPromise();

    const reportInformation = response && response.reportInformation ? response.reportInformation : undefined;
    const vehicleInformation = response && response.vehicleInformation ? response.vehicleInformation : undefined;

    this.reportInfo = {
      reportLocation: reportInformation &&  reportInformation.localReport ? reportInformation.localReport : undefined,
      surveyorDocument: reportInformation &&  reportInformation.localReport ? reportInformation.localReport : undefined,
      surveyorName: reportInformation &&  reportInformation.surveyor ? reportInformation.surveyor : undefined,
      vehicleBrand: vehicleInformation && vehicleInformation.brand ? vehicleInformation.brand : undefined,
      vehicleModel: vehicleInformation && vehicleInformation.model ? vehicleInformation.model : undefined,
      vehicleRenavam: vehicleInformation && vehicleInformation.renavam ? vehicleInformation.renavam : undefined,
      vehicleType: vehicleInformation && vehicleInformation.vehicleType ? vehicleInformation.vehicleType : undefined,
      vehicleModelYear: vehicleInformation && vehicleInformation.yearModel ? vehicleInformation.yearModel : undefined,
      vehicle0Km: vehicleInformation && vehicleInformation.vehicle0Km ? vehicleInformation.vehicle0Km : undefined,
    };

    this.renavam = this.reportInfo.vehicleRenavam;
    this.requestedRenavam = this.reportInfo.vehicleRenavam;
  }

  recordVehicleStates() {
    this.reportService.recordVehicleStates().subscribe((response) => {
      this.vehicleStates = response.vehicleStateDTO;
      this.originalVehicleStates = [...response.vehicleStateDTO];
    });
  }

  recordVehicleAccessories() {
    this.reportService.recordVehicleAccessories().subscribe((response) => {
      this.vehicleAccessories = response.vehicleAccessoryDTO;
      this.originalVehicleAccessories = [...response.vehicleAccessoryDTO];
    });
  }

  resetReport() {
    if (this.reportCopy) {
      if (this.vehicleAccessories) {
        this.vehicleAccessories.forEach(
          (acessory: VehicleAccessory, index: number) =>
            (acessory.selected = this.reportCopy.accessories[index].selected)
        );
      }

      this.vehicleStates.forEach((state: VehicleState, index: number) => {
        state.good = this.reportCopy.states[index].good;
        state.regular = this.reportCopy.states[index].regular;
        state.bad = this.reportCopy.states[index].bad;
      });

      this.renavam = this.reportCopy.renavam;
    } else {
      if (this.vehicleAccessories) {
        this.vehicleAccessories.forEach(
          (acessory: VehicleAccessory) => (acessory.selected = false)
        );
      }

      this.vehicleStates.forEach((state: VehicleState) => {
        state.good = false;
        state.regular = false;
        state.bad = false;
      });

      this.renavam = '';
    }
  }

  isReportDataValid(): boolean {
    return !!(
      this.vehicleStates &&
      this.vehicleStates.filter(
        (state: VehicleState) => state.good || state.regular || state.bad
      ).length === this.vehicleStates.length &&
      (this.renavam && this.renavam.length
        ? RenavanPartner.isValid(this.renavam)
        : this.reportInfo.vehicle0Km === 'S')
    );
  }

  goToStep(step: number) {
    this.reportStep = step;

    normalizeList(document.querySelectorAll('.modal')).forEach(
      (element: HTMLElement) => (element.scrollTop = 0)
    );
  }

  goToBackStep() {
    if (this.reportStep > 1) {
      this.goToStep(this.reportStep - 1);
    } else {
      this.dialodService.confirm({
        body: 'Ao fechar as informações inseridas serão descartadas, deseja continuar?',
        callbackSuccess: () => {
          this.closeReportModal();
          this.resetReport();
        },
      });
    }
  }

  handleChangeState(event: any, state: VehicleState) {
    ['good', 'regular', 'bad'].forEach((status) => (state[status] = false));

    state[event.target.value] = true;
  }

  handleChangeIncorrectRenavam(event: any) {
    if (event.target.checked) {
      setTimeout(() => this.inputRenavam.nativeElement.select(), 0);
    } else {
      this.renavam = this.requestedRenavam;
    }
  }

  handleBlurRenavam() {
    if (this.renavam && this.renavam.length) {
      this.isRenavamInvalid = !RenavanPartner.isValid(this.renavam);
    } else {
      this.isRenavamInvalid = this.reportInfo.vehicle0Km === 'N';
    }
  }

  get mustShowAviso() {
    return (
      this.timeline &&
      this.timeline.filter((time) => time.idStatus === 21)[0].dataHora ===
        undefined
    );
  }

  showAvisoDocumentacao() {
    const initialState = {};
    this.modalService.show(VisualizacaoDocumentacaoComponent, {
      ...appSettings.MODAL_PARAMS,
      initialState,
    });
  }
}
